<template>
	<div id="accountManagement">

		<div class="container">
			<!-- <div class="companyInfo">
				<div class="company_avatar">
					<img v-if="schoolInfo.logo" :src="schoolInfo.logo"></img>
					<div class="company_name" v-else>
						{{schoolInfo.company_name?schoolInfo.company_name.substring(0,1):''}}
					</div>
				</div>
				<div class="companyInfoRight">
					<div class="companyInfoName">
						{{ schoolInfo.company_name || '校招平台用户' }}
					</div>
					<div class="tags">
						<div class="item" v-if="schoolInfo.industry">
							{{schoolInfo.industry || ''}}
						</div>
						<div class="item" v-if="schoolInfo.scale">
							{{schoolInfo.scale || ''}}
						</div>
					</div>
				</div>
			</div> -->
			<div class="headerContainer">
				<div class="title">
					账户管理
				</div>
				<el-button type="primary" v-if="userInfo.is_main" @click="postPosition">添加子账号</el-button>
			</div>

			<div class="listContainer">
				<!-- <div class="title">
					生源列表
				</div> -->
				<div class="screenContainer">
					<!-- <div class="searchContainer">
						<div class="searchItem">
							<div class="iptName">
								类型：
							</div>
							<el-select v-model="job_type" placeholder="请选择">
								<el-option v-for="item in typeList" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
						<div class="searchItem">
							<div class="iptName">
								薪资：
							</div>
							<el-select v-model="salary_min" placeholder="请选择" @change='changeSalay1'>
								<el-option v-for="item in salaryArry1" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<el-select v-model="salary_max" placeholder="请选择" v-if="isshow">
								<el-option v-for="item in salaryArry2" :disabled='salaryDisabled' :key="item.value"
									:label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</div>
						<div class="searchItem">
							<div class="iptName">
								学历要求：
							</div>
							<el-select v-model="education" multiple placeholder="请选择">
								<el-option v-for="(item,index) in eduList" :key="index" :label="item" :value="item">
								</el-option>
							</el-select>
						</div>
						<div class="searchItem">
							<div class="iptName">
								人数：
							</div>
							<el-input v-model="job_num" type="number" placeholder="请输入招聘人数"></el-input>
						</div>
						<div class="searchItem">
							<div class="iptName">
								截止时间：
							</div>
							<el-date-picker v-model="end_time_et" :picker-options="pickerOptions" type="date"
								placeholder="选择日期">
							</el-date-picker>
						</div>

					</div> -->

					<div class="btnContainer">
						<!-- <div class="btn" style="margin-right: 12px;">
							<img src="../img/screen.png" alt="" />
							<div>
								筛选
							</div>
						</div> -->
						<!-- <div class="btn" style="background: #4E90F0;" @click="search">
							<img src="../img/search.png" alt="" />
							<div>
								搜索
							</div>
						</div> -->
					</div>
				</div>

				<div class="tableContainer">
					<el-table :data="jobList" border style="width: 100%" @selection-change="handleSelectionChange">
						<!-- <el-table-column type="selection" fixed width="55">
						</el-table-column> -->
						<el-table-column prop="avatar" label="账号头像" width="110">
							<template slot-scope="scope">
								<div class="one-line">
									<img :src="scope.row.avatar || defaultiImg(scope.row.user_id)" alt=""
										style="width:40px;height: 40px;border-radius: 50%;" />
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="username" label="账号名称" width="110">
						</el-table-column>
						<el-table-column prop="salary" label="账号类型" width="110">
							<template slot-scope="scope">
								<div class="one-line">
									{{scope.row.is_main?'超级管理员':'子帐号'}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="position" label="职务" width="200">
						</el-table-column>
						<el-table-column prop="tel" label="手机号" width="150">
						</el-table-column>
						<el-table-column prop="updated_at" label="注册时间">
						</el-table-column>
						<el-table-column fixed="right" label="操作" width="200">
							<template slot-scope="scope">
								
								<el-button class="compile" type="primary" v-if="!scope.row.is_main&&userInfo.is_main"
									@click="to(scope.row.id,scope.row.status)">{{scope.row.status?'注销':'开启'}}</el-button>
								<el-button class="delete" type="danger" @click="delJob1(scope.row.id)"
									v-if="!scope.row.is_main&&userInfo.is_main">删除</el-button>

								<el-button class="compile" disabled type="primary" style="opacity: 0.5;" v-if="scope.row.user_id==userInfo.user_id" >
									当前账号</el-button>


									<!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
								<el-button type="text" size="small">编辑</el-button> -->
							</template>
						</el-table-column>
					</el-table>
				</div>

				<!-- <div class="paging">
					<div class="pagingLeft">
						<el-button plain @click="previousPage">上一页</el-button>
						<el-button plain @click="nextPage">下一页</el-button>
						<el-button type="danger" @click="deleteJobItem" plain>删除</el-button>
					</div>
					<el-pagination background layout="total,prev, pager, next,jumper" :page-size='pageSizes'
						:total="total" @current-change='currentChange' :current-page='currentpage'>
					</el-pagination>
				</div> -->


			</div>
		</div>


		<el-dialog title="添加子账号" :visible.sync="dialogVisible" :close-on-click-modal='false' width="800px"
			:before-close="handleClose">

			<div class="elDialogContainer">
				<div class="ipt" style="margin-bottom: 30px;">
					<div class="text">
						<span style="color:#FF4A4A">*</span>子账号姓名
					</div>
					<el-input v-model="username" maxlength="10" placeholder="请输入子账号姓名"></el-input>
				</div>
				<div class="ipt" style="margin-bottom: 30px;">
					<div class="text">
						<span style="color:#FF4A4A">*</span>子账号职务
					</div>
					<el-input v-model="position" maxlength="10" placeholder="请输入子账号职务"></el-input>
				</div>
				<div class="ipt" style="margin-bottom: 30px;">
					<div class="text">
						<span style="color:#FF4A4A">*</span>子账号手机号
					</div>
					<el-input v-model="tel" maxlength="11" placeholder="请输入子账号手机号"></el-input>
				</div>
				<div class="ipt" style="margin-bottom: 30px;">
					<div class="text">
						子账号头像
					</div>
					<el-upload class="avatar-uploader1" style="width: 128px;"
						action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3" :show-file-list="false"
						:on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload">
						<img v-if="cover_image_url" :src="cover_image_url" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</div>
			</div>
			<el-button type="primary" @click="accountNumber">保存</el-button>
		</el-dialog>
	</div>
</template>
<script>
	import {
		mapMutations,
		mapState
	} from 'vuex'
	export default {
		data() {
			return {
				total: 100,
				pageSizes: 9,
				currentPage: 1,
				currentpage: 1,
				jobList: [],
				dialogVisible: false,

				cover_image_url: '', //账号头像
				username: '', //账号名称
				position: '', //子账号职务
				tel: '', //子账号手机号
			};
		},

		mounted() {
			console.log(this.userInfo)
			this.getmyJobList()

		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
			}),
		},
		methods: {
			...mapMutations(['setIslogin']),
			defaultiImg(user_id) {
				let ids = (user_id) % 26 || 0
				return `https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_${ids}.png`
			},
			// v2/school_job/add_subacc
			accountNumber() {
				this.username = this.username.trim()
				if (!this.username) {
					this.$message.error('请输入子帐号姓名!');
					return
				}

				this.position = this.position.trim()
				if (!this.position) {
					this.$message.error('请输入子帐号职务!');
					return
				}


				this.tel = this.tel.trim()
				if (!this.tel) {
					this.$message.error('请输入子帐号手机号!');
					return
				}
				const regex = /^1[3-9]\d{9}$/;

				if (!regex.test(this.tel)) {
					this.$message.error('请输入正确的子帐号手机号!');
					return
				}

				this.$util.post(
					"v2/school_job/add_subacc", {
						admin_id: this.schoolInfo.admin_id,
						avatar: this.cover_image_url,
						position: this.position,
						tel: this.tel,
						username: this.username,
					},
					(res) => {

						if (res.code == 0) {
							this.$message({
								message: '添加成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getmyJobList()
								this.dialogVisible = false
								this.position = ''
								this.tel = ''
								this.username = ''
								this.cover_image_url = ''

							}, 100)
						} else {
							this.$message.error(res.msg);
						}
					}
				);
			},
			handleClose(done) {
				this.position = ''
				this.tel = ''
				this.username = ''
				this.cover_image_url = ''
				done();
			},
			beforeAvatarUpload(file) {

				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 10;
				let img = isJPG || isPNG
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片格式错误!');
					return
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 10MB!');
					return
				}

				return isLt2M && img;
			},
			handleAvatarSuccess2(res) {
				this.cover_image_url = res.data.fileUrl;
			},
			handleSelectionChange(val) {

				this.selectList = val
			},
			deleteJobItem() {
				if (this.selectList.length > 0) {
					this.selectList.forEach((item) => {
						this.delJob(item.id)
					})
					setTimeout(() => {
						this.getmyJobList()
					}, 100)
				} else {
					this.$message({
						message: '请先选择删除项',
						type: 'warning'
					});
				}
			},
			delJob1(id) {
				this.$confirm(`您确定删除该子帐号吗，删除后子帐号无法恢复，请谨慎操作！`, '删除账户', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.delJob(id)
				}).catch(() => {});
			},
			delJob(job_id) {
				this.$util.post(
					"v2/school_job/del_subacc", {
						id: job_id,
					},
					(res) => {

						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getmyJobList()
							}, 100)
						} else {
							this.$message.error(res.msg);
						}
					}
				);
			},
			getmyJobList() {
				this.$util.post(
					"v2/school_job/getCompanyUserList", {
						admin_id: this.schoolInfo.admin_id,
					},
					(res) => {

						if (res.code == 0) {

							this.jobList = res.data
						}
					}
				);
			},
			$getTime(symbol = '-', status = 0, time = Date.now()) {
				let date = new Date(time)
				let Y = date.getFullYear() + symbol

				let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + symbol
				let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '

				let H = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
				let Minu = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
				let S = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
				switch (status) {
					case 0:
						return Y + M + D;
					case 1:
						return Y + M + D + H + Minu + S;
					default:
						break;
				}
			},
			getTime(dateTimeString) {
				const dateTime = new Date(dateTimeString);
				const year = dateTime.getUTCFullYear();
				const month = String(dateTime.getUTCMonth() + 1).padStart(2, '0');
				const day = String(dateTime.getUTCDate()).padStart(2, '0');
				// const hour = String(dateTime.getUTCHours()).padStart(2, '0');
				// const minute = String(dateTime.getUTCMinutes()).padStart(2, '0');
				// const second = String(dateTime.getUTCSeconds()).padStart(2, '0');

				const formattedDateTime = `${year}-${month}-${day}`;


				return formattedDateTime
			},


			postPosition() {
				// this.$router.push({
				// 	path: "/addPosition",
				// 	// query: {
				// 	//   id: 1,
				// 	// },
				// });

				this.dialogVisible = true
			},
			to(id, status) {
				let status1 = 0
				if (status) {
					status1 = 0
				} else {
					status1 = 1
				}
				this.$confirm(`您确定${status1?'开启':'注销'}该子帐号吗？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$util.post(
						"v2/school_job/is_open_subacc", {
							id: id,
							status: status1,
						},
						(res) => {

							if (res.code == 0) {
								this.$message({
									message: `操作成功`,
									type: 'success'
								});
								setTimeout(() => {
									this.getmyJobList()
								}, 100)
							} else {
								this.$message.error(res.msg);
							}
						}
					);
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
			},
			handleClick(row) {

				this.dialogVisible = true
				// this.$router.push({
				// 	path: "/jobDetails",
				// 	// query: {
				// 	//   id: 1,
				// 	// },
				// });
			},
			closeElDialog(done) {
				// this.dialogVisible = false
				done();
			},

			currentChange(page) {
				this.currentpage = page
				// this.currentpage = page
				// this.getEnterpriseList()
				this.getmyJobList()
			},
			previousPage() {
				if (this.currentpage > 1) {
					this.currentpage
					this.getmyJobList()
				}
			},
			nextPage() {
				if (Math.ceil(this.total / this.pageSizes) > this.currentpage) {
					this.currentpage++
					this.getmyJobList()
				}
			},
		},
		components: {},
	};
</script>
<style>
	.searchContainer .el-select {
		width: 185px !important;
	}

	.searchContainer .el-date-editor {
		width: 185px !important;
	}

	.listContainer .el-table .cell {
		text-align: center !important;
	}

	.listContainer .el-table__header th {
		background: #e9eeff;
		font-weight: 500 !important;
	}

	.listContainer .el-table__body td {
		background: #f9fbff;
	}

	.tableContainer .compile .el-button--primary {
		/* background-color: #4F8FF0;
		border-color: #4F8FF0; */
	}

	.tableContainer .delete .el-button--primary {
		background-color: #DC7777;
		border-color: #DC7777;
	}

	/* #positionManagement .el-dialog {
		background: initial;
		box-shadow: initial;
	} */
	#register .el-input__inner {
		font-size: 16px;
	}

	.companyContainer .el-input__inner {
		border: none !important;
		padding: 0 !important;
	}

	.avatarContainer .avatar-uploader .el-upload {
		border: 1px solid #E5E5E5;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background: #F5F7FA;

		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.avatarContainer .avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatarContainer .avatarUploader {
		width: 80px;
		height: 80px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.avatarContainer .avatar-uploader-icon1 {
		font-size: 14px;
		color: #8c939d;
		margin-bottom: 5px;
	}

	.avatarContainer .avatar-uploader span {
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}

	.avatar {
		width: 128px;
		height: 128px;
		display: block;
	}


	.environment {
		border: 1px solid #DCDFE6;
		flex: 1;
		background-color: #FFF;
		color: #606266;
		height: 40px;
		padding: 0 15px;
		border-radius: 4px;
		font-size: 14px;
		line-height: 40px;
	}




	#accountManagement .avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader1 .el-upload:hover {
		border-color: #409EFF;
	}


	#accountManagement .avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	.avatar {
		width: 128px;
		height: 128px;
		display: block;
	}
</style>
<style lang="less" scoped>
	.container {
		width: 100%;
		padding: 0 40px;

		.headerContainer {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #EEEEEE;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			.title {
				margin-right: 20px;
				font-weight: bold;
				font-size: 16px;
				color: #333;
			}

			.el-button--primary {
				// background-color: #0084FF !important;
				// border-color: #0084FF !important;
			}
		}

		.listContainer {
			// padding: 0 40px;

			// .title {
			// 	font-weight: bold;
			// 	font-size: 18px;
			// 	color: #2D3C50;
			// 	margin-bottom: 20px;
			// 	margin-left: 8px;
			// }

			.screenContainer {
				display: flex;
				align-items: baseline;
				margin-bottom: 20px;
			}

			.searchContainer {
				flex: 1;
				// padding-left: 8px;
				display: flex;
				align-items: center;
				flex-wrap: wrap;

				.searchItem {
					display: flex;
					align-items: center;
					margin-right: 15px;
					margin-bottom: 10px;

					.iptName {
						width: 75px;
						// text-align: right;
						font-weight: 400;
						font-size: 16px;
						color: #343232;
					}
				}


			}

			.btnContainer {

				display: flex;
				align-items: center;
				padding-right: 15px;

				.btn {
					width: 92px;
					height: 39px;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #FD8342;
					border-radius: 5px;
					font-size: 0;

					img {
						width: 16px;
						height: 16px;
						margin-right: 10px;
					}

					div {
						font-weight: 400;
						font-size: 14px;
						color: #FFFFFF;
					}

				}
			}

			.tableContainer {
				width: 100%;
			}
		}

	}

	.preview {
		.text {
			font-weight: 400;
			font-size: 16px;
			color: #2A2929;
			margin-bottom: 12px;
		}

		.btn {
			font-weight: 400;
			font-size: 16px;
			color: #004EFF;
			cursor: pointer;
		}
	}


	.paging {
		width: 100%;
		padding: 20px 0;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.pagingLeft {
			display: flex;
			align-items: center;

		}
	}



	.qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.qrcode {
			padding: 50px 100px;
			// width: 410px;
			// height: 390px;
			background: #FFFFFF;
			border-radius: 10px;
			border: 4px solid #0084FF;

			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;

			img {
				width: 208px;
				height: 208px;
				margin-bottom: 37px;
			}

			.hite1 {
				font-weight: bold;
				font-size: 24px;
				color: #333333;
				margin-bottom: 17px;
			}

			.hite2 {
				font-weight: 500;
				font-size: 18px;
				color: #333333;
			}
		}
	}

	// .elDialog {
	// 	position: relative;
	// 	font-size: 0;

	// 	.main {
	// 		box-sizing: border-box;
	// 		padding: 30px 50px 50px 50px;
	// 		background: #FFFFFF;
	// 		border-radius: 10px;

	// 		.title {
	// 			font-weight: bold;
	// 			font-size: 24px;
	// 			color: #2A2929;
	// 			margin-bottom: 30px;
	// 		}
	// 	}

	// 	.close {
	// 		position: absolute;
	// 		top: -28px;
	// 		right: -28px;
	// 		width: 32px;
	// 		height: 32px;
	// 		cursor: pointer;
	// 	}
	// }



	.elDialogContainer {

		.ipt {
			width: 700px;
			// display: flex;
			// align-items: center;
			margin-bottom: 28px;

			.text {
				// width: 135px;
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: 14px;
				color: #333333;
				margin-bottom: 20px;
			}

			.el-input {
				flex: 1 !important;
			}

			.el-select {
				flex: 1 !important;
			}

			.el-textarea {
				flex: 1 !important;
			}
		}
	}

	.companyInfo {
		width: 100%;
		padding: 20px 0 20px 0;
		border-bottom: 1px solid #EEEEEE;
		font-size: 0;
		display: flex;
		align-items: center;
		margin-bottom: 5px;

		// img {
		// 	width: 57px;
		// 	height: 57px;
		// 	border-radius: 50%;
		// 	background: #003987;
		// 	margin-right: 10px;
		// }

		.companyInfoRight {
			display: flex;
			justify-content: center;
			flex-direction: column;

			.companyInfoName {
				font-weight: 500;
				font-size: 18px;
				color: #2D3C50;
				margin-bottom: 10px;
			}

			.tags {
				display: flex;
				align-items: center;

				.item {
					padding: 2px 4px;
					border-radius: 5px;
					border: 1px solid #AEAEAE;
					font-weight: 500;
					font-size: 12px;
					color: #AEAEAE;
					margin-right: 5px;
				}
			}
		}
	}
</style>